import { requiredNullish } from '@breezeventures/web-ph-validators/zod-utils';
import { z } from 'zod';

import { documentSchema } from './document-schema';

export const bankAccountSchema = z.object({
  providerId: requiredNullish(z.string(), 'Select a bank'),
  beneficiaryName: z.string().trim().min(1, 'Bank account name is required'),
  accountNumber: z.string().trim().min(1, 'Bank account number is required'),
  proofsOfAccount: z
    .array(documentSchema)
    .min(1, 'Proof of bank account is required'),
});

export const getBankAccountSchema = (accountNumberRegex: RegExp) =>
  bankAccountSchema.extend({
    accountNumber: z
      .string()
      .min(1, 'Bank account number is required')
      .regex(accountNumberRegex, 'Enter the full account number'),
  });

export type BankAccountFormValues = z.infer<typeof bankAccountSchema>;
